import { render, staticRenderFns } from "./page-contact-two.vue?vue&type=template&id=237a4fb8&"
import script from "./page-contact-two.vue?vue&type=script&lang=js&"
export * from "./page-contact-two.vue?vue&type=script&lang=js&"
import style0 from "./page-contact-two.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports